import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale, LinearScale);

const API = window.location.hostname === 'localhost'
  ? 'http://localhost:5000/api'
  : 'https://myssa1.osc-fr1.scalingo.io/api';

const PALETTE = ['#3ab56f', '#bfc64b'];

const Camembertinventaire = () => {
  const [fait, setFait]       = useState(0);
  const [aFaire, setAFaire]   = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      fetch(`${API}/avancement_inventaire`).then(r => r.json()),
      fetch(`${API}/base_de_donne_item`).then(r => r.json()),
    ])
    .then(([avancement, items]) => {

      // Items uniques inventoriés (avancement_inventaire)
      const uniqueAvancements = new Set(
        avancement.map(row => String(row['Item'] || '').trim()).filter(Boolean)
      );

      // Items uniques total (base_de_donne_item)
      const uniqueItems = new Set(
        items.map(row => String(row['Item'] || '').trim()).filter(Boolean)
      );

      const nbFait   = uniqueAvancements.size;
      const nbTotal  = uniqueItems.size;
      const nbAFaire = Math.max(0, nbTotal - nbFait);

      setFait(nbFait);
      setAFaire(nbAFaire);
    })
    .catch(err => console.error('Erreur Camembertinventaire:', err))
    .finally(() => setLoading(false));
  }, []);

  const total      = fait + aFaire;
  const pctFait    = total > 0 ? Math.round((fait   / total) * 100) : 0;
  const pctAFaire  = total > 0 ? Math.round((aFaire / total) * 100) : 0;

  const data = {
    labels: [
      `Fait (${pctFait}% — ${fait} réf.)`,
      `À faire (${pctAFaire}% — ${aFaire} réf.)`,
    ],
    datasets: [{
      data: [fait, aFaire],
      backgroundColor: PALETTE.map(c => c + 'cc'),
      borderColor: '#ffffff',
      borderWidth: 2,
      hoverOffset: 6,
    }],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: 'SUIVI INVENTAIRE',
        color: '#042d04',
        font: { family: "'IBM Plex Mono', monospace", size: 20, weight: '500' },
        padding: { bottom: 16 },
      },
      tooltip: {
        backgroundColor: '#ffffff',
        borderColor: '#f0ece2',
        borderWidth: 1,
        titleColor: '#04202d',
        bodyColor: '#8b7b64',
        titleFont: { family: "'IBM Plex Mono', monospace", size: 20 },
        bodyFont: { family: "'IBM Plex Sans', sans-serif", size: 20 },
        padding: 10,
        callbacks: {
          label: (ctx) => {
            const val = ctx.raw;
            const pct = total > 0 ? Math.round((val / total) * 100) : 0;
            return ` ${val} références (${pct}%)`;
          },
        },
      },
      legend: {
        position: 'bottom',
        labels: {
          color: '#8b7b64',
          font: { family: "'IBM Plex Sans', sans-serif", size: 15 },
          boxWidth: 12,
          boxHeight: 12,
          padding: 14,
        },
      },
    },
  };

  return (
    <div style={{
      background: '#ffffff',
      border: '1px solid #f0ece2',
      borderRadius: '14px',
      padding: '20px 24px',
      boxShadow: '0 2px 12px rgba(148, 99, 46, 0.06)',
      position: 'relative',
      overflow: 'hidden',
      width: '400px',
      height: '440px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', borderRadius: '14px 14px 0 0' }} />
      {loading
        ? <span style={{ color: '#8b7b64', fontFamily: "'IBM Plex Mono', monospace", fontSize: 12 }}>Chargement…</span>
        : <Pie data={data} options={options} width={800} height={360} />
      }
    </div>
  );
};

export default Camembertinventaire;